import React, { useEffect, useState } from 'react';
import { getDrmPfDocumentDownload } from "@/api/baseData";
import { useLoadingStore } from "@/stores/loading";
import ConfirmModal from "@/components/ConfirmModal";
import {
  MESSAGE_NO_E39,
} from "@/config";
import { useUserStore } from '@/stores/user';
import { useNavigate } from 'react-router-dom';

interface DataDocuments {
  document_name?: string,
  filename?: string,
  original_filename?: string,
  release_date?: string,
  remarks?: string,
  filepath?: string
}

export default function BasicInfoDetail() {
  const navigate = useNavigate();
  const setLoading = useLoadingStore(state => state.setLoading);
  const user = useUserStore(state => state.user);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [dataDocuments, setDetails] = useState<DataDocuments[]>([]);
  const [isShowErrorModal, setIsShowErrorModal] = useState(false);

  useEffect(() => {
    setLoading(true)
    const response = getDrmPfDocumentDownload();
    response.then(result => {
      setDetails(result.data.dataDocuments);
      console.log(result);      
    }).catch(error => {
      console.log("error");
      setErrorMessage(MESSAGE_NO_E39);
    }).finally(() => {
      setLoading(false);
    });
  }, [])

  useEffect(() => {
    if (errorMessage) {
      setIsShowErrorModal(true);
    }
  }, [errorMessage])

  return (
    <div>
      <div className="info-tbl_wrap uk-margin-small-top">
        <table className="download-tbl uk-width-1-1 w-download">
          <tbody>
            <tr>
            <th className="number"></th>
            <th className="label"></th>
              <th className="label">資料名</th>
              <th className="label">更新年月日</th>
              <th className="label">備考</th>
            </tr>
            {dataDocuments.length !== 0 && dataDocuments.map((item, index) => (
              <tr key={index}>
                <td>{index+1}</td>
                <td>{item.document_name}</td>
                <td><a href={item.filepath} target="_blank">{item.original_filename}</a></td>
                <td>{item.release_date}</td>
                <td className="content line_break">{item.remarks}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {errorMessage &&
          <ConfirmModal
              text={errorMessage}
              confirmButtonText="OK"
              isShow={isShowErrorModal}
              onConfirm={() => {
                setIsShowErrorModal(false);
                setErrorMessage(null);
                navigate("/download");
              }}
          />
        }
    </div>
  );
}
